import routerOptions0 from "/usr/local/jpom-server/data/build/7daceafa0f854abd8b960acbdc1f4b3d/source/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@22.7.9_eslint@9.13.0_jiti@2.4.2__ioredis@5.4.1__tscmnggexcsfpkkiv6umnhtrzq/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}